import { useBCMSModal } from "@bcm-dev/bcms-vite";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from "compid/custom-ui/CustomModal";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function WantToLeaveModal
 * @param {FUNCTION} onClick - Allows us to set an event handler on click to the primary "Leave" button. 
 * @exported true
 * @returns {React.Component}
 * @description This is the modal that shows when the user tries to leave a workflow to alert them that information entered will be lost.
 * @example
 * <WantToLeaveModal />
 */
export default function WantToLeaveModal(props) {
  const { close } = useBCMSModal();
  const onClick = evt => {
    props.data.onLeave(evt);
    close("WantToLeaveModal");
  }
  return(
    <CustomModal id="WantToLeaveModal" className="want-to-leave-modal large-icon-modal">
      <CustomModalContent className="flex-container flex-horizontal align-top">
        <div className="set-width">
          <SVGAsset id="AlertTriangleIcon" className="alert-icon left-icon" />
        </div>
        <div className="flex-width">
          <h4 className="modal-title"><b>Are you sure you want to leave?</b></h4>
          <p className="sub-text">Any information you entered will be lost when you leave this page.</p>
        </div>
      </CustomModalContent>
      <CustomModalFooter className="form-button-container button-container flex-container flex-horizontal align-center">
        <ModalCloseButton text="Stay" id="WantToLeaveModal" />
        <ModalPrimaryButton text="Leave" onClick={ onClick } />
      </CustomModalFooter>
    </CustomModal>
  );
}